import type { ReactNode } from "react";
import Breadcrumb from "./Breadcrumb";

interface Crumb {
  label: string;
  to?: string;
}

interface Props {
  title: string;
  subtitle?: string;
  desc?: string;
  crumbs: Crumb[];
  children?: ReactNode;
}

export default function PageHeader({ title, subtitle, desc, crumbs, children }: Props) {
  return (
    <section className="relative pt-28 md:pt-36 pb-8 md:pb-12 border-b border-background-200/70 bg-gradient-to-b from-background-100 to-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Breadcrumb items={crumbs} />
        <div className="mt-5 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <h1 className="font-heading text-3xl md:text-4xl text-foreground-950">{title}</h1>
            {subtitle && (
              <p className="mt-2 text-primary-500 font-heading text-sm md:text-base comic-pop">{subtitle}</p>
            )}
            {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl">{desc}</p>}
          </div>
          {children}
        </div>
      </div>
    </section>
  );
}